import { BaseDataService } from './BaseDataService';
import { UserScoreCardNote } from '../../models';
import { NotificationService } from '../../services';

export class UserScoreCardNoteDataService extends BaseDataService<UserScoreCardNote> {
    constructor(notificationService: NotificationService) {
        super('User Score Card Note', 'User Score Card Notes', notificationService);
    }
    
    public getAllByUser(userId: number, scoreCardId: number): Promise<any> {
        const endpoint = `${this.endpointRoot}/all/${userId}/${scoreCardId}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving characterisics.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }

}


// WEBPACK FOOTER //
// ./src/services/api/UserScoreCardNoteDataService.tsx